import $ from 'jquery'
import forEach from 'lodash-es/forEach'

const debug = require('debug')('pm:message-overlay')

export const MessageOverlay = {
  HOOK_SELF: '.js-message-overlay',
  HOOK_CLOSE: '.js-close-overlay',
  HOOK_ACTIVE_CLASS: 'c-message-overlay--active',
  currentAnimations: [],
  defaultDuration: 4000,
  defaultType: 'info',
  isActive: false,

  init: function () {
    MessageOverlay.isActive = false
    MessageOverlay.activeClass = 'c-message-overlay--active'

    $(document).on('click', '.js-close-overlay', MessageOverlay.close)
  },

  show: function (text, type, duration) {
    debug('show', text, type, duration)

    type = type || MessageOverlay.defaultType
    duration = duration || MessageOverlay.defaultDuration

    const markup =
      '<div class="c-message-overlay c-message-overlay--' +
      type +
      ' js-message-overlay">' +
      '<a href="#" class="c-message-overlay_close js-close-overlay">&times;</a>' +
      '<p class="c-message-overlay_text">' +
      text +
      '</p></div>'

    // Check if there's an active overlay
    if (MessageOverlay.isActive) {
      const $overlay = $(MessageOverlay.HOOK_SELF)
      MessageOverlay.clearAnimations()
      $overlay.removeClass(MessageOverlay.HOOK_ACTIVE_CLASS)

      // When the existing overlay is done sliding out
      setTimeout(function () {
        $overlay.remove()
        MessageOverlay.isActive = false
        MessageOverlay.animate(markup, duration)
      }, 200)
    } else {
      MessageOverlay.animate(markup, duration)
    }
  },

  animate: function (markup, duration) {
    MessageOverlay.isActive = true
    $('body').append(markup)

    MessageOverlay.checkAnnouncement()

    // Start animating the overlay
    MessageOverlay.currentAnimations.push(
      setTimeout(function () {
        const $overlay = $(MessageOverlay.HOOK_SELF)
        $overlay.addClass(MessageOverlay.HOOK_ACTIVE_CLASS)

        // When the overlay is done showing
        MessageOverlay.currentAnimations.push(
          setTimeout(function () {
            $overlay.removeClass(MessageOverlay.HOOK_ACTIVE_CLASS)

            // When the CSS animation is finished
            MessageOverlay.currentAnimations.push(
              setTimeout(function () {
                $overlay.remove()
                MessageOverlay.isActive = false
                MessageOverlay.clearAnimations()
              }, 200)
            )
          }, duration)
        )
      }, 15)
    )
  },

  clearAnimations: function () {
    forEach(MessageOverlay.currentAnimations, function (item) {
      clearTimeout(item)
    })
    MessageOverlay.currentAnimations = []
  },

  close: function (event) {
    event.preventDefault()
    MessageOverlay.clearAnimations()

    $(MessageOverlay.HOOK_SELF).fadeOut(150, function () {
      $(this).remove()
      MessageOverlay.isActive = false
    })
  },

  checkAnnouncement: function () {
    // This ensures that the message overlays position right under the announcement, if present
    const $announcement = $('.announcement')
    const scrollTop = $(window).scrollTop()

    // If the announcement exists
    // And if the user is scrolled to where it's visible
    if ($announcement.length > 0 && scrollTop <= $announcement.height()) {
      $(MessageOverlay.HOOK_SELF).css({
        top: $announcement.height() - scrollTop + 15,
      })
    }
  },
}

$(MessageOverlay.init)
